const roundNumber = (number, digits = 2) => {
  return Math.round((number + Number.EPSILON) * 10 ** digits) / 10 ** digits
}

export default roundNumber
